import { qualificationConfig } from './Type'

export const initialQualificationConfig: qualificationConfig = {
  situation_guarantor_needed: [],
  situation_guarantor_asked: [],
  revenue_ratio_include_benefits: false,
  rules: [],
  need_booking: true,
  need_form: true,
  need_uploads: true,
  allow_dossier_facile: true,
  guarantor_and_applicant_solvent_required: false,
}
